import Panel from '../Panel';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import PeerGroupDetails from './PeerGroupDetails';

/**
 * Renders a list of attributes relating to the peer group of a selected portfolio
 * (Geo Category, Style, Market Cap Focus, number of portfolios in peer group).
 *
 * This is the PeerGroupDetails component within a panel, with a title.
 *
 * @component
 * @param selectedPortfolio - Currently selected portfolio
 * @param peerCount - Number of portfolios in selected portfolio's peer group
 * @returns {React.ReactElement} The rendered ProPeerGroupPanelDesktop component
 */
const ProPeerGroupPanelDesktop = ({ selectedPortfolio, peerCount }) => {
    return (
        <Panel
            sx={{
                paddingLeft: '3rem',
                paddingTop: '2.5rem',
                flexDirection: 'column',
                height: '100%'
            }}
            data-analyticsid='portfolio-drilldown-peer-group'
        >
            <Typography variant='h2' sx={{ paddingBottom: 2 }}>
                Peer Group
            </Typography>
            <Box
                display='flex'
                height='100%'
                alignItems='center'
                sx={{ paddingLeft: 0.5 }}
            >
                <PeerGroupDetails
                    selectedPortfolio={selectedPortfolio}
                    peerCount={peerCount}
                />
            </Box>
        </Panel>
    );
};

ProPeerGroupPanelDesktop.propTypes = {
    selectedPortfolio: PropTypes.object,
    peerCount: PropTypes.number
};

export default ProPeerGroupPanelDesktop;
